import { render, staticRenderFns } from "./CampaignsProductNameFilterInput.vue?vue&type=template&id=0b07d44a&"
import script from "./CampaignsProductNameFilterInput.vue?vue&type=script&lang=js&"
export * from "./CampaignsProductNameFilterInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports